import type {
  LoginRes,
  PrivateUserProfile,
} from '@milestone-portal/api/actions/auth/auth.types';

import { ZustandIDBStorage } from '@milestone-portal/common/others/storage/ZustandIDBStorage';
import { getOpenReplay } from '@milestone-portal/utils/open-replay';
import {
  sentryCaptureException,
  sentrySetUser,
} from '@milestone-portal/utils/sentry';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface Auth {
  authData?: LoginRes;
  removeUser: () => void;
  setAuthData: (data?: LoginRes) => void;
  setUser: (data: PrivateUserProfile) => void;
}

const STORAGE_NAME = 'auth-storage';

export const useAuthStore = create<Auth>()(
  devtools(
    persist(
      (set, get) => ({
        authData: undefined,
        removeUser: () => {
          set({ authData: undefined });
        },
        setAuthData: (data) => {
          try {
            const user = data?.user;
            if (user?.custom_url) {
              getOpenReplay()?.setUserID(user.custom_url.toString());
              sentrySetUser({
                id: user.custom_url,
              });
            }
          } catch (error) {
            sentryCaptureException(error);
          }
          set({ authData: data });
        },
        setUser: (data) => {
          const { authData } = get();
          if (!authData) return;
          set({
            authData: {
              ...authData,
              user: data,
            },
          });
        },
      }),
      {
        name: STORAGE_NAME,
        partialize: (state) => ({ authData: state.authData }),
        storage: new ZustandIDBStorage(),
      }
    ),
    {
      name: STORAGE_NAME,
    }
  )
);
